var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:思源黑体;src:url(" + escape(require("./fonts/SourceHanSansCN-Regular.otf")) + ") format(\"truetype\");font-weight:400;font-style:normal}", ""]);

// exports
